import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  base: '/collect/',
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },


  routes: [
    {
      path: '/customEdit',
      name: 'customEdit',
      component: () => import('@/views/customPage/edit/index.vue')
    },
    {
      path: '/emptyCount',
      name: 'emptyCount',
      meta: {
        isLogin: true
      },
      component: () => import('@/views/customPage/empty/empty.vue')
    },

    {
      path: '/dlbzLogin',
      name: 'dlbzLogin',
      meta: {
        isLogin: true
      },
      component: resolve => require(['../views/user/dlbzLogin.vue'], resolve)
    },
    {
      path: '/lsFoodLogin',
      name: 'lsFoodLogin',
      meta: {
        isLogin: true
      },
      component: resolve => require(['../views/user/lsFoodLogin.vue'], resolve)
    },
    {
      path: '/greenFoodLogin',
      name: 'greenFoodLogin',
      meta: {
        isLogin: true
      },
      component: resolve => require(['../views/user/greenFoodLogin.vue'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        isLogin: true
      },
      component: resolve => require(['../views/user/login.vue'], resolve)
    },
    {
      path: '/login1',
      name: 'login1',
      meta: {
        isLogin: true
      },
      component: resolve => require(['../views/user/login1.vue'], resolve)
    },
    {
      path: '/ztLogin',
      name: 'ztLogin',
      meta: {
        isLogin: true
      },
      component: resolve => require(['../views/user/ztLogin.vue'], resolve)
    },
    {
      path: '/nanlogin',
      name: 'nanlogin',
      meta: {
        isLogin: true
      },
      component: resolve => require(['../views/user/naLogin.vue'], resolve)
    },
    {
      path: '/topicLibrary',
      name: 'topicLibrary',
      meta: {
        isLogin: true
      },
      component: resolve => require(['../views/user/topicLibrary.vue'], resolve)
    },
    {
      path: '/doorIndex',
      name: 'doorIndex',
      component: resolve => require(['../views/door/doorIndex/index.vue'], resolve), //门户首页
      meta: {
        canKeep: false
      }
    },
    {
      path: '*',
      component: () => import('../components/error/NotFoundComponent')
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['../views/user/register.vue'], resolve)
    },
    {
      path: '/',
      name: 'index',
      component: resolve => require(['../components/layout/index.vue'], resolve), //首页,
      alias: '/index',
      children: [{
          path: '/prodBaseInfo',
          name: 'prodBaseInfo',
          component: resolve => require(['../views/productInfo/prodBaseInfo.vue'], resolve),
          meta: {
            canKeep: false,
            name: '/productregist'
          }
        }, {
          path: '/prodInfoWrite',
          name: 'prodInfoWrite',
          component: resolve => require(['../views/productInfo/prodInfoWrite.vue'], resolve),
          meta: {
            canKeep: false,
            name: '/productregist'
          }
        }, {
          path: 'massSpectaList',
          name: 'massSpectaList',
          component: resolve => require(['../views/massSpecta/massSpectaList.vue'], resolve), //质谱数据列表
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/massSpectaList'
          }
        }, {
          path: 'massSpectaAdd',
          name: 'massSpectaAdd',
          component: resolve => require(['../views/massSpecta/massSpectaAdd.vue'], resolve), //添加质谱数据
          meta: {
            canKeep: false,
            name: '/massSpectaList'
          }
        },
        {
          path: 'massSpectaToview',
          name: 'massSpectaToview',
          component: resolve => require(['../views/massSpecta/massSpectaToview.vue'], resolve), //查看质谱数据
          meta: {
            canKeep: false,
            name: '/massSpectaList'
          }
        },
        {
          path: 'massSpectaUpload',
          name: 'massSpectaUpload',
          component: resolve => require(['../views/massSpecta/massSpectaUpload.vue'], resolve), //导入质谱数据
          meta: {
            canKeep: false,
            name: '/massSpectaList'
          }
        }, {
          path: 'standSpectrumList',
          name: 'standSpectrumList',
          component: resolve => require(['../views/standSpectrum/standSpectrumList.vue'], resolve), //标谱数据列表
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/standSpectrumList'
          }
        }, {
          path: 'standSpectrumAdd',
          name: 'standSpectrumAdd',
          component: resolve => require(['../views/standSpectrum/standSpectrumAdd.vue'], resolve), //添加标谱数据
          meta: {
            canKeep: false,
            name: '/standSpectrumList'
          }
        },
        {
          path: 'standSpectrumToview',
          name: 'standSpectrumToview',
          component: resolve => require(['../views/standSpectrum/standSpectrumToview.vue'], resolve), //查看标谱数据
          meta: {
            canKeep: false,
            name: '/standSpectrumList'
          }
        },
        {
          path: 'cpdList',
          name: 'cpdList',
          component: resolve => require(['../views/system/cpdList.vue'], resolve), //化合物管理
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/cpdList'
          }
        },
        {
          path: 'userAdd',
          name: 'userAdd',
          component: resolve => require(['../views/system/userAdd.vue'], resolve), //用户添加
          meta: {
            canKeep: false,
            name: 'userAdd'
          }
        },
        {
          path: 'userList',
          name: 'userList',
          component: resolve => require(['../views/system/userList.vue'], resolve), //用户管理
          meta: {
            canKeep: false,
            name: 'userList'
          }
        },
        {
          path: 'cpdListAdd',
          name: 'cpdListAdd',
          component: resolve => require(['../views/system/cpdListAdd.vue'], resolve), //化合物添加
          meta: {
            canKeep: false,
            name: '/cpdList'
          }
        },
        {
          path: 'cpdUpload',
          name: 'cpdUpload',
          component: resolve => require(['../views/system/cpdUpload.vue'], resolve), //化合物下载上传
          meta: {
            canKeep: false,
            name: '/cpdList'
          }
        },
        {
          path: 'apparatusList',
          name: 'apparatusList',
          component: resolve => require(['../views/system/apparatusList.vue'], resolve), //仪器管理
          meta: {
            canKeep: false,
            name: '/apparatusList'
          }
        },
        {
          path: 'apparatusListAdd',
          name: 'apparatusListAdd',
          component: resolve => require(['../views/system/apparatusListAdd.vue'], resolve), //仪器添加
          meta: {
            canKeep: false,
            name: '/apparatusList'
          }
        },
        {
          path: 'Compound',
          name: 'Compound',
          component: resolve => require(['../views/system/Compound.vue'], resolve), //化合物类型管理
          meta: {
            canKeep: false,
            name: '/Compound'
          }
        },
        {
          path: 'CompoundSearch',
          name: 'CompoundSearch',
          component: resolve => require(['../views/system/CompoundSearch.vue'], resolve), //化合物类型查询
          meta: {
            name: '/CompoundSearch'
          }
        },
        {
          path: 'Category',
          name: 'Category',
          component: resolve => require(['../views/system/Category.vue'], resolve), //化合物类型管理
          meta: {
            canKeep: false,
            name: '/Category'
          }
        },
        {
          path: 'Compoundadd',
          name: 'Compoundadd',
          component: resolve => require(['../views/system/Compoundadd.vue'], resolve), //添加类型
          meta: {
            canKeep: false,
            name: '/Compound'
          }
        },
        {
          path: 'CategoryAdd',
          name: 'CategoryAdd',
          component: resolve => require(['../views/system/CategoryAdd.vue'], resolve), //添加
          meta: {
            canKeep: false,
            name: '/Category'
          }
        },
        {
          path: 'home',
          name: 'home',
          component: resolve => require(['../views/home/index.vue'], resolve), //首页
          meta: {
            canKeep: false,
            name: '/home'
          }
        },
        {
          path: 'hhData',
          name: 'hhData',
          component: resolve => require(['../views/dataQuery/hhData.vue'], resolve), //化合物数据查询
          meta: {
            keepAlive: false,
            canKeep: false,
            name: '/hhData'
          }
        },
        {
          path: 'yqData',
          name: 'yqData',
          component: resolve => require(['../views/dataQuery/yqData.vue'], resolve), //仪器数据查询
          meta: {
            canKeep: false,
            name: '/yqData'
          }
        },
        {
          path: 'zpData',
          name: 'zpData',
          component: resolve => require(['../views/dataQuery/zpData.vue'], resolve), //质谱监测数据查询
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/zpData'
          }
        },
        {
          path: 'bzData',
          name: 'bzData',
          component: resolve => require(['../views/dataQuery/bzData.vue'], resolve), //标准谱图数据查询
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/bzData'
          }
        },

        {
          path: 'subList',
          name: 'subList',
          component: resolve => require(['../views/systemConfig/subList.vue'], resolve), //用户管理
          meta: {
            canKeep: false
          }
        },
        {
          path: 'yjList',
          name: 'yjList',
          component: resolve => require(['../views/systemConfig/yjList.vue'], resolve), //意见反馈
          meta: {
            canKeep: false,
            name: '/yjList'
          }
        },
        {
          path: 'advertisementList',
          name: 'advertisementList',
          component: resolve => require(['../views/systemConfig/advertisementList.vue'], resolve), //广告管理
          meta: {
            canKeep: false,
            name: '/advertisementList'
          }
        },
        {
          path: 'weList',
          name: 'weList',
          component: resolve => require(['../views/systemConfig/weList.vue'], resolve), //关于我们管理
          meta: {
            canKeep: false,
            name: '/weList'
          }
        },
        {
          path: 'helpList',
          name: 'helpList',
          component: resolve => require(['../views/systemConfig/helpList.vue'], resolve), //帮助中心
          meta: {
            canKeep: false,
            name: '/helpList'
          }
        },
        {
          path: 'special',
          name: 'special',
          component: resolve => require(['../views/systemConfig/special.vue'], resolve), //帮助中心
          meta: {
            canKeep: false,
            name: '/special'
          }
        },
        {
          path: 'subjecType',
          name: 'subjecType',
          component: resolve => require(['../views/systemConfig/subjecType.vue'], resolve), //专题分类
          meta: {
            canKeep: false,
            name: '/subjecType'
          }
        },
        {
          path: 'advertiAdd',
          name: 'advertiAdd',
          component: resolve => require(['../views/systemConfig/advertiAdd.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/advertiAdd'
          }
        },
        {
          path: 'advertiTable',
          name: 'advertiTable',
          component: resolve => require(['../views/systemConfig/advertiTable.vue'], resolve), //广告列表
          meta: {
            canKeep: false,
            name: '/advertisementList'
          }
        },
        {
          path: 'friendLinkAdd',
          name: 'friendLinkAdd',
          component: resolve => require(['../views/systemConfig/friendLinkAdd.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/friendLink'
          }
        },
        {
          path: 'friendLink',
          name: 'friendLink',
          component: resolve => require(['../views/systemConfig/friendLink.vue'], resolve), //广告列表
          meta: {
            canKeep: false,
            name: '/friendLink'
          }
        },
        {
          path: 'specialAdd',
          name: 'specialAdd',
          component: resolve => require(['../views/systemConfig/specialAdd.vue'], resolve), //广告列表
          meta: {
            canKeep: false,
            name: '/special'
          }
        },
        {
          path: 'weAdd',
          name: 'weAdd',
          component: resolve => require(['../views/systemConfig/weAdd.vue'], resolve), //关于我们添加
          meta: {
            canKeep: false,
            name: '/weList'
          }
        },
        {
          path: 'addUs',
          name: 'addUs',
          component: resolve => require(['../views/system/addUs.vue'], resolve), //用户添加
          meta: {
            canKeep: false
          }
        },
        {
          path: 'USList',
          name: 'USList',
          component: resolve => require(['../views/system/USList.vue'], resolve), //系统用户管理
          meta: {
            canKeep: false
          }
        },
        {
          path: 'sHist',
          name: 'sHist',
          component: resolve => require(['../views/productInfo/sHist.vue'], resolve), //产品登记列表审核
          meta: {
            name: '/sHist'
          }
        },
        {
          path: 'productregist',
          name: 'productregist',
          component: resolve => require(['../views/productInfo/productregist.vue'], resolve), //产品登记列表
          meta: {
            name: '/productregist'
          }
        },
        {
          path: 'preview',
          name: 'preview',
          component: resolve => require(['../views/productInfo/preview.vue'], resolve), //产品登记列表预览
          meta: {
            canKeep: false,
            name: '/productregist'
          }
        },
        {
          path: 'geogList',
          name: 'geogList',
          component: resolve => require(['../views/productInfo/geogList.vue'], resolve), //地理标志信息
          meta: {
            name: '/geogList'
          }
        },
        {
          path: 'geogAdd',
          name: 'geogAdd',
          component: resolve => require(['../views/productInfo/geogAdd.vue'], resolve), //地理标志信息添加
          meta: {
            name: '/geogList'
          }
        },
        {
          path: 'samplingLink',
          name: 'samplingLink',
          component: resolve => require(['../views/basisData/samplingLink.vue'], resolve), //采样环节管理
          meta: {
            canKeep: false,
            name: '/samplingLink'
          }
        },
        {
          path: 'samplingLinkAdd',
          name: 'samplingLinkAdd',
          component: resolve => require(['../views/basisData/samplingLinkAdd.vue'], resolve), //采样环节管理
          meta: {
            canKeep: false,
            name: '/samplingLink'
          }
        },
        {
          path: 'ncpclassify',
          name: 'ncpclassify',
          component: resolve => require(['../views/basisData/ncpclassify.vue'], resolve), //农产品分类管理
          meta: {
            canKeep: false,
            name: '/ncpclassify'
          }
        },
        {
          path: 'zycclassify',
          name: 'zycclassify',
          component: resolve => require(['../views/basisData/zycclassify.vue'], resolve), //中药材分类管理
          meta: {
            canKeep: false,
            name: '/zycclassify'
          }
        },
        {
          path: 'ProductCategory',
          name: 'ProductCategory',
          component: resolve => require(['../views/basisData/ProductCategory.vue'], resolve), //农产品分类管理
          meta: {
            canKeep: false,
            name: '/ProductCategory'
          }
        },
        {
          path: 'projectType',
          name: 'projectType',
          component: resolve => require(['../views/basisData/projectType.vue'], resolve), // 项目类型管理
          meta: {
            canKeep: false,
            name: '/projectType'
          }
        },
        {
          path: 'projectTypeAdd',
          name: 'projectTypeAdd',
          component: resolve => require(['../views/basisData/projectTypeAdd.vue'], resolve), // 项目类型管理
          meta: {
            canKeep: false,
            name: '/projectType'
          }
        },

        {
          path: 'indicatorUnit',
          name: 'indicatorUnit',
          component: resolve => require(['../views/basisData/indicatorUnit.vue'], resolve), //指标单位管理
          meta: {
            canKeep: false,
            name: '/indicatorUnit'
          }
        },

        {
          path: 'indicatorUnitAdd',
          name: 'indicatorUnitAdd',
          component: resolve => require(['../views/basisData/indicatorUnitAdd.vue'], resolve), //指标单位管理
          meta: {
            canKeep: false,
            name: '/indicatorUnit'
          }
        },

        {
          path: 'administration',
          name: 'administration',
          component: resolve => require(['../views/administration/index.vue'], resolve), //数据管理
          meta: {
            canKeep: false,
            name: '/administration'
          }
        },
                {
          path: 'taskCompletion',
          name: 'taskCompletion',
          component: resolve => require(['../views/administration/taskCompletion.vue'], resolve), //完成情况
          meta: {
            canKeep: false,
            name: '/taskCompletion'
          }
        },
        {
          path: 'dataTemplate',
          name: 'dataTemplate',
          component: resolve => require(['../views/administration/dataTemplate.vue'], resolve), //数据模板
          meta: {
            canKeep: false,
            name: '/administration'
          }
        },
        {
          path: 'dataTemplates',
          name: 'dataTemplates',
          component: resolve => require(['../views/administration/dataTemplate.vue'], resolve), //数据模板
          meta: {
            canKeep: false,
            name: '/Project'
          }
        },
        {
          path: 'projectData',
          name: 'projectData',
          component: resolve => require(['../views/administration/projectData.vue'], resolve), //管理项目数据
          // meta:{keepAlive: true,canKeep:false}
          meta: {
            name: '/administration'
          }
        },
          {
          path: 'report',
          name: 'report',
          component: resolve => require(['../views/administration/report.vue'], resolve), //检测报告
          // meta:{keepAlive: true,canKeep:false}
          meta: {
            name: '/administration'
          }
        },
        {
          path: 'projectdUpload',
          name: 'projectdUpload',
          component: resolve => require(['../views/administration/projectdUpload.vue'], resolve), //导入
          meta: {
            canKeep: false,
            name: '/administration'
          }
        },
        {
          path: 'editadd',
          name: 'editadd',
          component: resolve => require(['../views/administration/editadd.vue'], resolve), //样品编辑
          meta: {
            canKeep: false,
            name: '/administration'
          }
        },
        {
          path: 'greenEditadd',
          name: 'greenEditadd',
          component: resolve => require(['../views/administration/greenEditadd.vue'], resolve), //样品编辑
          meta: {
            canKeep: false,
            name: '/administration'
          }
        },
        {
          path: 'details',
          name: 'details',
          component: resolve => require(['../views/administration/details.vue'], resolve), //风味口感编辑等
          meta: {
            canKeep: false,
            name: '/administration'
          }
        },
        {
          path: 'Project',
          name: 'Project',
          component: resolve => require(['../views/administration/Project.vue'], resolve), //项目管理
          meta: {
            canKeep: false,
            name: '/Project'
          }
        },
        {
          path: 'ProjectAdd',
          name: 'ProjectAdd',
          component: resolve => require(['../views/administration/ProjectAdd.vue'], resolve), //添加项目
          meta: {
            canKeep: false,
            name: '/Project'
          }
        },
        {
          path: 'criteria',
          name: 'criteria',
          component: resolve => require(['../views/administration/criteria.vue'], resolve), //添加项目
          meta: {
            canKeep: false,
            name: '/administration'
          }
        },
        {
          path: 'roleGl',
          name: 'roleGl',
          component: resolve => require(['../views/manage/roleGl.vue'], resolve), //角色管理
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/roleGl'
          }
        },
        {
          path: 'roleAdd',
          name: 'roleAdd',
          component: resolve => require(['../views/manage/roleAdd.vue'], resolve), //添加角色
          meta: {
            canKeep: false,
            name: '/roleGl'
          }
        },
        {
          path: 'testJg',
          name: 'testJg',
          component: resolve => require(['../views/manage/testJg.vue'], resolve), //检测机构
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/testJg'
          }
        },
        {
          path: 'legalJg',
          name: 'legalJg',
          component: resolve => require(['../views/manage/legalJg.vue'], resolve), //法人单位管理
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/legalJg'
          }
        },
        {
          path: 'testJgAdd',
          name: 'testJgAdd',
          component: resolve => require(['../views/manage/testJgAdd.vue'], resolve), //检测机构添加
          meta: {
            canKeep: false,
            name: '/testJg'
          }
        },
        {
          path: 'legalAdd',
          name: 'legalAdd',
          component: resolve => require(['../views/manage/legalAdd.vue'], resolve), //检测机构添加
          meta: {
            canKeep: false,
            name: '/legalJg'
          }
        },
        {
          path: 'skillJgAdd',
          name: 'skillJgAdd',
          component: resolve => require(['../views/manage/skillJgAdd.vue'], resolve), //技术机构添加
          meta: {
            canKeep: false,
            name: '/testJg'
          }
        },
        {
          path: 'basicInfoFr',
          name: 'basicInfoFr',
          component: resolve => require(['../views/manage/basicInfoFr.vue'], resolve), //法人单位基本信息修改
          meta: {
            canKeep: false,
            name: '/basicInfo'
          }
        },
        {
          path: 'basicInfo',
          name: 'basicInfo',
          component: resolve => require(['../views/manage/basicInfo.vue'], resolve), //法人单位基本信息修改
          meta: {
            canKeep: false,
            name: '/basicInfo'
          }
        },
        {
          path: 'basicInfoJg',
          name: 'basicInfoJg',
          component: resolve => require(['../views/manage/basicInfoJg.vue'], resolve), //技术机构基本信息修改
          meta: {
            canKeep: false,
            name: '/basicInfo'
          }
        },
        {
          path: 'accountSettings',
          name: 'accountSettings',
          component: resolve => require(['../views/user/accountSettings.vue'], resolve), //账户设置
          meta: {
            canKeep: false,
            name: '/accountSettings'
          }
        },
        {
          path: 'subAccount',
          name: 'subAccount',
          component: resolve => require(['../views/user/subAccount.vue'], resolve), //单位子账户
          meta: {
            canKeep: true,
            name: '/subAccount'
          }
        },
        {
          path: 'subAccountAdd',
          name: 'subAccountAdd',
          component: resolve => require(['../views/user/subAccountAdd.vue'], resolve), //单位子账户添加
          meta: {
            canKeep: true,
            name: '/subAccount'
          }
        },
        {
          path: 'institutional',
          name: 'institutional',
          component: resolve => require(['../views/user/institutional.vue'], resolve), //单位子账户
          meta: {
            canKeep: true,
            name: '/institutional'
          }
        },
                {
          path: 'institutionalAdd',
          name: 'institutionalAdd',
          component: resolve => require(['../views/user/institutionalAdd.vue'], resolve), //单位子账户
          meta: {
            canKeep: true,
            name: '/institutional'
          }
        },
        {
          path: 'auPara',
          name: 'auPara',
          component: resolve => require(['../views/user/auPara.vue'], resolve), //授权参数管理
          meta: {
            canKeep: true,
            name: '/auPara'
          }
        },
        {
          path: 'auParaInfo',
          name: 'auParaInfo',
          component: resolve => require(['../views/user/auParaInfo.vue'], resolve), //授权参数信息
          meta: {
            canKeep: true,
            name: '/auPara'
          }
        },
        {
          path: 'auImport',
          name: 'auImport',
          component: resolve => require(['../views/user/auImport.vue'], resolve), //授权参数信息导入
          meta: {
            canKeep: true,
            name: '/auPara'
          }
        },
        {
          path: 'adminUser',
          name: 'adminUser',
          component: resolve => require(['../views/user/adminUser.vue'], resolve), //管理员用户
          meta: {
            canKeep: false,
            name: '/adminUser'
          }
        },
        {
          path: 'adminUserAdd',
          name: 'adminUserAdd',
          component: resolve => require(['../views/user/adminUserAdd.vue'], resolve), //新增管理员用户
          meta: {
            canKeep: false,
            name: '/adminUser'
          }
        },
        {
          path: 'hxwzUser',
          name: 'hxwzUser',
          component: resolve => require(['../views/user/hxwzUser.vue'], resolve), //化学物质特征用户
          meta: {
            canKeep: false,
            name: '/hxwzUser'
          }
        },
        {
          path: 'infoTb',
          name: 'infoTb',
          component: resolve => require(['../views/manage/infoTb.vue'], resolve), //信息填报
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/infoCent'
          }
        },
        {
          path: 'infoAdd',
          name: 'infoAdd',
          component: resolve => require(['../views/manage/infoAdd.vue'], resolve), //信息填报
          meta: {
            canKeep: false,
            name: '/infoCent'
          }
        },
        {
          path: 'infoCent',
          name: 'infoCent',
          component: resolve => require(['../views/manage/infoCent.vue'], resolve), //信息填报
          meta: {
            canKeep: false,
            name: '/infoCent',
            keepAlive: true
          }
        },
        // {
        //   path: 'doorIndex',
        //   name:'doorIndex',
        //   component: resolve => require(['../views/door/doorIndex/index.vue'], resolve),//门户首页
        //   meta:{canKeep:false}
        // }, 
        {
          path: 'auditList',
          name: 'auditList',
          component: resolve => require(['../views/xinxAudit/auditList.vue'], resolve), //信息审核
          meta: {
            keepAlive: true,
            canKeep: false,
            name: '/auditList'
          }
        },
        {
          path: 'auditSubList',
          name: 'auditSubList',
          component: resolve => require(['../views/xinxAudit/auditSubList.vue'], resolve), //信息审核子列表
          meta: {
            name: '/auditList',
            canKeep: false
          }
        }, {
          path: 'auditInfo',
          name: 'auditInfo',
          component: resolve => require(['../views/xinxAudit/auditInfo.vue'], resolve), //信息审核子列表
          meta: {
            name: '/auditList'
          }
        },
        {
          path: 'TaskManagement',
          name: 'TaskManagement',
          component: resolve => require(['../views/administration/TaskManagement.vue'], resolve), //风险任务列表
          meta: {
            name: '/TaskManagement'
          }

        },
        {
          path: 'Taskdetails',
          name: 'Taskdetails',
          component: resolve => require(['../views/administration/Taskdetails.vue'], resolve), //风险任务编辑添加
          meta: {
            name: '/TaskManagement'
          }

        },
        {
          path: 'setupQualificat',
          name: 'setupQualificat',
          component: resolve => require(['../views/user/setupQualificat.vue'], resolve), //单位资质机构
          meta: {
            canKeep: true,
            name: '/setupQualificat'
          }
        },
        {
          path: 'limitStandSql',
          name: 'limitStandSql',
          component: resolve => require(['../views/limitStandSql/index.vue'], resolve), //单位资质机构
          meta: {
            canKeep: true,
            keepAlive: true,
            name: '/limitStandSql'
          }
        },
        {
          path: 'limitStandAdd',
          name: 'limitStandAdd',
          component: resolve => require(['../views/limitStandSql/limitStandAdd.vue'], resolve), //单位资质机构
          meta: {
            canKeep: true,
            name: '/limitStandSql'
          }
        },
        {
          path: 'limitStandList',
          name: 'limitStandList',
          component: resolve => require(['../views/limitStandSql/limitStandList.vue'], resolve), //单位资质机构
          meta: {
            canKeep: true,
            name: '/limitStandSql'
          }
        },
        {
          path: 'limitStandSqlAdd',
          name: 'limitStandSqlAdd',
          component: resolve => require(['../views/limitStandSql/limitStandSqlAdd.vue'], resolve), //单位资质机构
          meta: {
            canKeep: true,
            name: '/limitStandSql'
          }
        },

        {
          path: 'varietiesSummary',
          name: 'varietiesSummary',
          component: resolve => require(['../views/monitoringData/varietiesSummary.vue'], resolve), //各品种汇总
          meta: {
            canKeep: true,
            name: '/varietiesSummary'
          }
        },

        {
          path: 'testParameters',
          name: 'testParameters',
          component: resolve => require(['../views/monitoringData/testParameters.vue'], resolve), //各检测参数汇总
          meta: {
            canKeep: true,
            name: '/testParameters'
          }
        },
        {
          path: 'cityPzSummary',
          name: 'cityPzSummary',
          component: resolve => require(['../views/monitoringData/cityPzSummary.vue'], resolve), //各城市按品种汇总
          meta: {
            canKeep: true,
            name: '/cityPzSummary'
          }
        },
        {
          path: 'cityJcSummary',
          name: 'cityJcSummary',
          component: resolve => require(['../views/monitoringData/cityJcSummary.vue'], resolve), //各城市按检测汇总
          meta: {
            canKeep: true,
            name: '/cityJcSummary'
          }
        },
        {
          path: 'samplingPzSummary',
          name: 'samplingPzSummary',
          component: resolve => require(['../views/monitoringData/samplingPzSummary.vue'], resolve), //抽样环节按品种汇总
          meta: {
            canKeep: true,
            name: '/samplingPzSummary'
          }
        },
        {
          path: 'samplingJcSummary',
          name: 'samplingJcSummary',
          component: resolve => require(['../views/monitoringData/samplingJcSummary.vue'], resolve), //抽样环节按检测汇总
          meta: {
            canKeep: true,
            name: '/samplingJcSummary'
          }
        },
        {
          path: 'productDatabase',
          name: 'productDatabase',
          component: resolve => require(['../views/dataMament/productDatabase.vue'], resolve), //产品数据库
          meta: {
            canKeep: false,
            name: '/productDatabase',
            keepAlive: true
          }
        },
                {
          path: 'greenFood',
          name: 'greenFood',
          component: resolve => require(['../views/dataMament/greenFood.vue'], resolve), //产品数据库
          meta: {
            canKeep: true,
            name: '/greenFood',
            keepAlive: false
          }
        },
         {
          path: 'greenFoodAdd',
          name: 'greenFoodAdd',
          component: resolve => require(['../views/dataMament/greenFoodAdd.vue'], resolve), //产品数据库
          meta: {
            canKeep: false,
            name: '/greenFood',
            keepAlive: false
          }
        },
        {
          path: 'landmark',
          name: 'landmark',
          component: resolve => require(['../views/dataMament/landmark.vue'], resolve), //产品数据库
          meta: {
            canKeep: false,
            name: '/landmark',
            keepAlive: false
          }
        },
        {
          path: 'landmarkAdd',
          name: 'landmarkAdd',
          component: resolve => require(['../views/dataMament/landmarkAdd.vue'], resolve), //产品数据库
          meta: {
            canKeep: false,
            name: '/landmark',
            keepAlive: false
          }
        },
                {
          path: 'library',
          name: 'library',
          component: resolve => require(['../views/dataMament/library.vue'], resolve), //产品数据库
          meta: {
            canKeep: false,
            name: '/library',
            keepAlive: false
          }
        },
        {
          path: 'libraryAdd',
          name: 'libraryAdd',
          component: resolve => require(['../views/dataMament/libraryAdd.vue'], resolve), //产品数据库
          meta: {
            canKeep: false,
            name: '/library',
            keepAlive: false
          }
        },
        {
          path: 'productDataBaseAdd',
          name: 'productDataBaseAdd',
          component: resolve => require(['../views/dataMament/productDataBaseAdd.vue'], resolve), //产品数据库新增
          meta: {
            canKeep: true,
            name: '/productDatabase'
          }
        },
        {
          path: 'meanIndicators',
          name: 'meanIndicators',
          component: resolve => require(['../views/dataMament/meanIndicators.vue'], resolve), //指标均值数据管理
          meta: {
            canKeep: false,
            name: '/meanIndicators',
            keepAlive: true
          }
        },
        {
          path: 'averageValue',
          name: 'averageValue',
          component: resolve => require(['../views/dataMament/averageValue.vue'], resolve), // 平均值数据管理
          meta: {
            canKeep: false,
            name: '/meanIndicators',
            keepAlive: false
          }
        },
        {
          path: 'productMainManagement',
          name: 'productMainManagement',
          component: resolve => require(['../views/dataMament/productMainManagement.vue'], resolve), //产品主要指标管理
          meta: {
            canKeep: false,
            name: '/productMainManagement',
            keepAlive: true
          }
        },
        {
          path: 'productMainManagementAdd',
          name: 'productMainManagementAdd',
          component: resolve => require(['../views/dataMament/productMainManagementAdd.vue'], resolve), //产品主要指标管理新增
          meta: {
            canKeep: true,
            name: '/productMainManagement'
          }
        },

        {
          path: 'Feedback',
          name: 'Feedback',
          component: resolve => require(['../views/lmpz/Feedback.vue'], resolve), //科普交流管理
          meta: {
            canKeep: true,
            name: '/Feedback'
          }
        },
        {
          path: 'kpjlList',
          name: 'kpjlList',
          component: resolve => require(['../views/lmpz/kpjlList.vue'], resolve), //科普交流管理
          meta: {
            canKeep: true,
            name: '/kpjlList'
          }
        },
        {
          path: 'kpjlLmgl',
          name: 'kpjlLmgl',
          component: resolve => require(['../views/lmpz/kpjlLmgl.vue'], resolve), //科普交流栏目管理
          meta: {
            canKeep: true,
            name: '/kpjlList'
          }
        },
        {
          path: 'kpjlAddEdit',
          name: 'kpjlAddEdit',
          component: resolve => require(['../views/lmpz/kpjlAddEdit.vue'], resolve), //科普交流栏目添加编辑
          meta: {
            canKeep: true,
            name: '/kpjlList'
          }
        },
        {
          path: 'kpjlDetails',
          name: 'kpjlDetails',
          component: resolve => require(['../views/lmpz/kpjlDetails.vue'], resolve), //科普交流栏目详情
          meta: {
            canKeep: true,
            name: '/kpjlList'
          }
        },
        {
          path: 'newsList',
          name: 'newsList',
          component: resolve => require(['../views/lmpz/newsList.vue'], resolve), //新闻动态管理
          meta: {
            canKeep: true,
            name: '/newsList'
          }
        },
        {
          path: 'newsLmgl',
          name: 'newsLmgl',
          component: resolve => require(['../views/lmpz/newsLmgl.vue'], resolve), //新闻动态栏目管理
          meta: {
            canKeep: true,
            name: '/newsList'
          }
        },
        {
          path: 'newsAddEdit',
          name: 'newsAddEdit',
          component: resolve => require(['../views/lmpz/newsAddEdit.vue'], resolve), //新闻动态栏目添加编辑
          meta: {
            canKeep: true,
            name: '/newsList'
          }
        },
        {
          path: 'newsDetails',
          name: 'newsDetails',
          component: resolve => require(['../views/lmpz/newsDetails.vue'], resolve), //新闻动态管理详情
          meta: {
            canKeep: true,
            name: '/newsList'
          }
        },
        {
          path: 'aboutusList',
          name: 'aboutusList',
          component: resolve => require(['../views/lmpz/aboutusList.vue'], resolve), //关于我们管理
          meta: {
            canKeep: true,
            name: '/aboutusList'
          }
        },
        {
          path: 'aboutasAddEdit',
          name: 'aboutasAddEdit',
          component: resolve => require(['../views/lmpz/aboutasAddEdit.vue'], resolve), //关于我们管理新增编辑
          meta: {
            canKeep: true,
            name: '/aboutusList'
          }
        },
        {
          path: 'adviseList',
          name: 'adviseList',
          component: resolve => require(['../views/lmpz/adviseList.vue'], resolve), //广告管理
          meta: {
            canKeep: true,
            name: '/adviseList'
          }
        },
        {
          path: 'adviseInfo',
          name: 'adviseInfo',
          component: resolve => require(['../views/lmpz/adviseInfo.vue'], resolve), //广告管理列表
          meta: {
            canKeep: true,
            name: '/adviseList'
          }
        },
        {
          path: 'adviseAddEdit',
          name: 'adviseAddEdit',
          component: resolve => require(['../views/lmpz/adviseAddEdit.vue'], resolve), //广告管理新增编辑
          meta: {
            canKeep: true,
            name: '/adviseList'
          }
        },
        {
          path: 'homeFloor',
          name: 'homeFloor',
          component: resolve => require(['../views/doorHomeset/homeFloor.vue'], resolve), //门户首页配置
          meta: {
            canKeep: true,
            name: '/homeFloor'
          }
        },
        {
          path: 'seasonalProRec',
          name: 'seasonalProRec',
          component: resolve => require(['../views/doorHomeset/seasonalProRec.vue'], resolve), //时令产品推荐管理
          meta: {
            canKeep: true,
            name: '/homeFloor',
            keepAlive: true,
          }
        },
        {
          path: 'areaSpecialRec',
          name: 'areaSpecialRec',
          component: resolve => require(['../views/doorHomeset/areaSpecialRec.vue'], resolve), //区域特色推荐管理
          meta: {
            canKeep: true,
            name: '/homeFloor',
            keepAlive: true,
          }
        },
        {
          path: 'proClassRec',
          name: 'proClassRec',
          component: resolve => require(['../views/doorHomeset/proClassRec.vue'], resolve), //产品分类推荐管理
          meta: {
            canKeep: true,
            name: '/homeFloor'
          }
        },
        {
          path: 'flavorMap',
          name: 'flavorMap',
          component: resolve => require(['../views/doorHomeset/flavorMap.vue'], resolve), //风味谱图管理
          meta: {
            canKeep: true,
            name: '/homeFloor'
          }
        },
        {
          path: 'riskControl',
          name: 'riskControl',
          component: resolve => require(['../views/doorHomeset/riskControl.vue'], resolve), //风险管控
          meta: {
            canKeep: true,
            name: '/homeFloor'
          }
        },
        {
          path: 'specialAttent',
          name: 'specialAttent',
          component: resolve => require(['../views/doorHomeset/specialAttention.vue'], resolve), //特别关注链接
          meta: {
            canKeep: true,
            name: '/homeFloor'
          }
        },
        {
          path: 'technicalBodies',
          name: 'technicalBodies',
          component: resolve => require(['../views/doorHomeset/technicalBodies.vue'], resolve), //技术机构链接
          meta: {
            canKeep: true,
            name: '/homeFloor'
          }
        },
        {
          path: 'subStatiionTopic',
          name: 'subStatiionTopic',
          component: resolve => require(['../views/doorHomeset/subStatiionTopic.vue'], resolve), //分站专题
          meta: {
            canKeep: true,
            name: '/homeFloor'
          }
        },
        {
          path: 'cyIndicatorManagement',
          name: 'cyIndicatorManagement',
          component: resolve => require(['../views/dataMament/cyIndicatorManagement.vue'], resolve), //风险管控
          meta: {
            canKeep: false,
            name: '/cyIndicatorManagement',
            keepAlive: true
          }
        },
        {
          path: 'cyIndicatorManagementAdd',
          name: 'cyIndicatorManagementAdd',
          component: resolve => require(['../views/dataMament/cyIndicatorManagementAdd.vue'], resolve), //风险管控
          meta: {
            canKeep: false,
            name: '/cyIndicatorManagement'
          }
        },
        {
          path: 'managementIndex',
          name: 'managementIndex',
          component: resolve => require(['../views/administration/managementIndex.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/meanIndicators'
          }
        },
        {
          path: 'assignment',
          name: 'assignment',
          component: resolve => require(['../views/administration/assignment.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/assignment'
          }
        },
        {
          path: 'assignmentdetails',
          name: 'assignmentdetails',
          component: resolve => require(['../views/administration/assignmentdetails.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/assignment'
          }
        },
        // {
        //   path: 'map',
        //   name:'map',
        //   component: resolve => require(['../views/administration/map.vue'], resolve),//
        //   meta:{canKeep:false,name:'/assignment'}
        // }, 
        {
          path: 'TestReport',
          name: 'TestReport',
          component: resolve => require(['../views/administration/TestReport.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/TestReport'
          }
        },
        {
          path: 'TestReportdetails',
          name: 'TestReportdetails',
          component: resolve => require(['../views/administration/TestReportdetails.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/TestReport'
          }
        },
        {
          path: 'agencypage',
          name: 'agencypage',
          component: resolve => require(['../views/administration/agencypage.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/Project'
          }
        },
        {
          path: 'flavorChart',
          name: 'flavorChart',
          component: resolve => require(['../views/featureDataBase/flavorChart.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/flavorChart'
          }
        },
        {
          path: 'comDataStatistics',
          name: 'comDataStatistics',
          component: resolve => require(['../views/featureDataBase/comDataStatistics.vue'], resolve), //综合数据统计
          meta: {
            canKeep: false,
            name: '/comDataStatistics'
          }
        },
        {
          path: 'pzZwDataBase',
          name: 'pzZwDataBase',
          component: resolve => require(['../views/featureDataBase/pzZwDataBase.vue'], resolve), //
          meta: {
            canKeep: false,
            name: '/pzZwDataBase'
          }
        },
        {
          path: 'database',
          name: 'database',
          component: resolve => require(['../views/database/database.vue'], resolve), //产品数据库
          meta: {
            name: '/database'
          }
        },
        {
          path: 'databaseAdd',
          name: 'databaseAdd',
          component: resolve => require(['../views/database/databaseAdd.vue'], resolve), //产品数据库
          meta: {
            name: '/database'
          }
        },
        {
          path: 'variety',
          name: 'varietyDatabase',
          component: resolve => require(['../views/database/varietyDatabase.vue'], resolve), //品种数据库
          meta: {
            name: '/variety'
          }
        },
        {
          path: 'varietyDatabaseAdd',
          name: 'varietyDatabaseAdd',
          component: resolve => require(['../views/database/varietyDatabaseAdd.vue'], resolve), //品种数据库-添加
          meta: {
            name: '/variety'
          }
        },
        {
          path: 'varietyDatabaseUpload',
          name: 'varietyDatabaseUpload',
          component: resolve => require(['../views/database/varietyDatabaseUpload.vue'], resolve), //品种数据库-导入
          meta: {
            name: '/variety'
          }
        },
        {
          path: 'material',
          name: 'material',
          component: resolve => require(['../views/database/material.vue'], resolve), //产品数据库
          meta: {
            name: '/material'
          }
        },
        {
          path: 'materialAdd',
          name: 'materialAdd',
          component: resolve => require(['../views/database/materialAdd.vue'], resolve), //产品数据库
          meta: {
            name: '/material'
          }
        },
        {
          path: 'datprojectdUpload',
          name: 'datprojectdUpload',
          component: resolve => require(['../views/database/datprojectdUpload.vue'], resolve), //导入模板
          meta: {
            name: '/material'
          }
        },
        {
          path: 'cxfb',
          name: 'cxfb',
          component: resolve => require(['../views/monitoringDataFx/cxFb.vue'], resolve), //导入模板
          meta: {
            name: '/cxfb'
          }
        },
        {
          path: 'ypfb',
          name: 'ypfb',
          component: resolve => require(['../views/monitoringDataypfb/ypfb.vue'], resolve), //导入模板
          meta: {
            name: '/ypfb'
          }
        },
        {
          path: 'apply',
          name: 'apply',
          component: resolve => require(['../views/pzpj/apply.vue'], resolve), //评价标签申请
          meta: {
            name: '/apply'
          }
        },
        {
          path: 'applyju',
          name: 'applyju',
          component: resolve => require(['../views/pzpj/applyju.vue'], resolve), //标签申请记录
          meta: {
            name: '/applyju'
          }
        },
        {
          path: 'bqsl',
          name: 'bqsl',
          component: resolve => require(['../views/pzpj/bqsl.vue'], resolve), //标签上链记录
          meta: {
            name: '/bqsl'
          }
        },
        {
          path: 'bqcx',
          name: 'bqcx',
          component: resolve => require(['../views/pzpj/bqcx.vue'], resolve), //标签查询记录
          meta: {
            name: '/bqcx'
          }
        },
        {
          path: 'assessmentList',
          name: 'assessmentList',
          component: () => import('@/views/pzpj/assessmentList.vue'),
          meta: {
            name: '/assessmentList'
          }
        }, {
          path: 'assessmentAdd',
          name: 'assessmentAdd',
          component: () => import('@/views/pzpj/assessmentAdd.vue'),
          meta: {
            name: '/assessmentList'
          }
        },
        {
          path: 'wzxx',
          name: 'wzxx',
          component: () => import('@/views/pzpj/wzxx.vue'),
          meta: {
            name: '/assessmentList'
          }
        },
      ]
    },
    {
      path: '/directPage',
      name: 'directPage',
      component: resolve => require(['../views/user/directPage.vue'], resolve)
    },
  ],

});
router.beforeEach((to, from, next) => {
  if (to.name == 'seasonalProRec' || to.name == 'areaSpecialRec') {
    to.meta.keepAlive = true;
  }
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js